import { Pressable, View } from 'react-native'
import { Text } from '@/components/ui/Text'
import { useThemeColors } from '@/contexts/ThemeContext'

const OPTIONS = [25, 50, 100, 200] as const

export function LimitSelector({
  value,
  onChange,
}: {
  value: number
  onChange: (v: number) => void
}) {
  const colors = useThemeColors()

  return (
    <View className="flex-row items-center gap-1.5">
      {OPTIONS.map((opt) => {
        const active = opt === value
        return (
          <Pressable
            key={opt}
            onPress={() => onChange(opt)}
            className="px-2.5 py-1 rounded-full border-[1.5px] active:opacity-70"
            style={{
              borderColor: active ? colors.primary : colors.border,
              backgroundColor: active ? `${colors.primary}15` : 'transparent',
            }}
          >
            <Text
              className="text-[11px] font-semibold"
              style={{ color: active ? colors.primary : colors.muted }}
            >
              {opt}
            </Text>
          </Pressable>
        )
      })}
    </View>
  )
}
